(() => {
  const root = document.querySelector('.main-product__media');
  if (!root) return; // product page only

  const re = /\[badge:\s*([^\]]+)\]/i;

  const apply = (img) => {
    if (!img || img.dataset.brBadgeDone === '1') return;

    const alt = img.getAttribute('alt') || '';
    const match = alt.match(re);
    if (!match) return;

    const text = match[1]?.trim();
    if (!text) return;

    const wrap = img.closest('.media');
    if (!wrap) return;

    if (wrap.querySelector('.br-media-badge')) return;

    wrap.classList.add('br-media-has-badge');

    const badge = document.createElement('div');
    badge.className = 'br-media-badge';
    badge.textContent = text;
    wrap.prepend(badge);

    img.setAttribute('alt', alt.replace(re, '').trim());
img.dataset.brBadgeDone = '1';
img.setAttribute('data-br-badge-done', '1');


  };

  // initial scan
  root.querySelectorAll('img[alt*="[badge:"]').forEach(apply);

  // handle swiper + lazy-loaded images
  const observer = new MutationObserver((mutations) => {
    for (const m of mutations) {
      for (const node of m.addedNodes) {
        if (!(node instanceof HTMLElement)) continue;
        if (node.matches?.('img[alt*="[badge:"]')) apply(node);
        node.querySelectorAll?.('img[alt*="[badge:"]').forEach(apply);
      }
    }
  });

  observer.observe(root, { childList: true, subtree: true });

// stop observing once we've processed all badge-tagged images
const stopIfDone = () => {
  const remaining = root.querySelectorAll('img[alt*="[badge:"]:not([data-br-badge-done="1"])').length;
  if (remaining === 0) observer.disconnect();
};
stopIfDone();
setTimeout(stopIfDone, 1500);

})();
